import { HandleType, Product, SlidingDoorComponent } from '@inter-ikea-storageone/range';
import { ComponentIds, Entity } from '@inter-ikea-core/core';
import { CommunicationSizeComponent } from '@inter-ikea-core/core';
import { getAllowedHandleTypes } from '../utils/frontLayouts';

export const matchHandleTypeToFronts = (products: Product[], entitiesInScene: Entity[]) => {
  const frontsInScene = entitiesInScene.filter(
    entity =>
      entity.hasComponent(ComponentIds.DOOR_COMPONENT_ID) ||
      entity.hasComponent(ComponentIds.DRAWER_COMPONENT_ID) ||
      entity.hasComponent(SlidingDoorComponent.id)
  );
  if (frontsInScene.length === 0) {
    return products;
  }

  const frontsWithIntegratedHandles = frontsInScene.filter(
    front => getAllowedHandleTypes(front).length === 0
  );

  if (frontsInScene.length === frontsWithIntegratedHandles.length) {
    return [];
  }
  const supportedHandleTypesInScene = frontsInScene.flatMap(front => getAllowedHandleTypes(front));
  return products.filter(product =>
    supportedHandleTypesInScene.includes(product.type as HandleType)
  );
};

export const matchHandleSizeToFrontsInScene = (products: Product[], entitiesInScene: Entity[]) => {
  const handleDoorConnectorEdgesDiff = 40;
  const doors = entitiesInScene.filter(e => e.hasComponent(ComponentIds.DOOR_COMPONENT_ID));
  const drawers = entitiesInScene.filter(e => e.hasComponent(ComponentIds.DRAWER_COMPONENT_ID));
  if (doors.length === 0 && drawers.length === 0) {
    return products;
  }
  const doorHeights = doors
    .map(
      door =>
        door.getComponent<CommunicationSizeComponent>(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)
          ?.size.height
    )
    .filter(Boolean) as number[];
  const drawerWidths = drawers
    .map(
      door =>
        door.getComponent<CommunicationSizeComponent>(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)
          ?.size.width
    )
    .filter(Boolean) as number[];

  return products.filter(product => {
    const handleHeight = product.communicatedDimensions.height;
    return [...doorHeights, ...drawerWidths].some(
      size => handleHeight <= size - handleDoorConnectorEdgesDiff
    );
  });
};

export const matchWidthToFramesInScene = (products: Product[], entitiesInScene: Entity[]) => {
  const framesInScene = entitiesInScene.filter(entity =>
    entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)
  );
  if (framesInScene.length === 0) {
    return products;
  }
  const frameWidths = framesInScene
    .map(
      entity =>
        entity.getComponent<CommunicationSizeComponent>(
          ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
        )?.size.width
    )
    .filter((width): width is number => !!width);

  return products.filter(product => frameWidths.includes(product.communicatedDimensions.width));
};

export const matchHeightToFramesInScene = (products: Product[], entitiesInScene: Entity[]) => {
  const framesInScene = entitiesInScene.filter(entity =>
    entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)
  );
  const frameHeights = framesInScene
    .map(
      entity =>
        entity.getComponent<CommunicationSizeComponent>(
          ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
        )?.size.height
    )
    .filter((width): width is number => !!width);

  return products.filter(product => frameHeights.includes(product.communicatedDimensions.height));
};
